<!--
/*******************************************************************************
*@ 화면명     : AcnCertn
*@ 화면설명   : 계좌인증 공통
*@ 사용전문   : RBF0404B40 - 예금계좌상세조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <NOSComponent ref="NOS_COMPONENT" :component="this.NOS_INSTANCE.components" />
    <div class="scroll">
      <!--"MOTP-01-04-01-01": "계좌 인증"-->
      <!--"MOTP-01-04-01-02": "등록된 출금 계좌를 이용하여 본인 인증을 합니다.<br/>출금계좌를 선택하고 계좌 비밀번호를 입력하세요."-->
      <contents-header
        :bg-type="true"
        :no-radius="true"
        title="MOTP-01-04-01-01"
        description="MOTP-01-04-01-02"
      ></contents-header>

      <article class="contents">
        <div>
          <form class="form">
            <div class="form-text-field">
              <!--"MOTP-01-04-01-03": "출금 계좌번호"-->
              <acno-select-box
                in-acn-knd="1"
                in-acn-dtl-knd="2"
                :label="$t('MOTP-01-04-01-03')"
                :value.sync="getRBF0404B40.acnoSelect.acno"
                :detailValue.sync="getRBF0404B40.acnoSelect.acnoDetail"
                @change="acnoChange"
              />
            </div>
            <div class="form-text-field">
              <label for="name" class="form-label">
                <!--계좌 비밀번호-->
                {{$t("MOTP-01-04-01-04")}}
              </label>
              <!-- <div class="input-text-field" @click="type2 = true">
                <input
                  type="password"
                  id="brncoEcrypPwd"
                  class="form-control password"
                  placeholder="비밀번호 입력"
                  :value="getRBF0404B40.in.brncoEcrypPwd"
                  @input="e => (getRBF0404B40.in.brncoEcrypPwd = e.currentTarget.value)"
                />
              </div>-->
              <div class="input-text-field" @click="type2 = true">
                <div class="item-desc">
                  <acno-password
                    id="brncoEcrypPwd"
                    ref="brncoEcrypPwd"
                    :NOS_INSTANCE_REFERANCE="NOS_INSTANCE"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="notice notice-box--type">
          <div class="notice-tit">
            <p class="bullet">{{/*유의사항*/$t("MOTP-01-04-01-05")}}</p>
          </div>
          <div class="notice-cont">
            <p>
              <!--계좌 비밀번호를 3회 연속 틀리실 경우 해당 계좌는 이용이 제한되며, 계좌 재이용을 위해 영업점 방문이 필요합니다.-->
              {{$t("MOTP-01-04-01-06")}}
            </p>
          </div>
        </div>
      </article>
    </div>
    <!-- {{getRBF0404B40}} -->
    <div class="btn-area--full fixed">
      <button
        :class="
          `btn md ${
            getRBF0404B40.acnoSelect.acno !== '' &&
            getRBF0404B40.acnoSelect.acnoDetail.acnKnd !== '' &&
            this.NOS_INSTANCE.toJSON().brncoEcrypPwd !== '' &&
            this.NOS_INSTANCE.toJSON().brncoEcrypPwd.length === 4
              ? 'normal'
              : 'disabled'
          }`
        "
        v-on:click="FN001"
      >{{/*인증하기*/$t("MOTP-01-04-01-07")}}</button>
    </div>
  </article>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Common from "@/components/basic/Common";
import AcnoSelectBox from "@/components/page/common/AcnoSelectBox";
import NOSComponent from "@/components/page/pluginFree/NOSComponent";
import NOSController from "@/components/page/pluginFree/NOSController";
import AcnoPassword from "@/components/page/common/AcnoPassword";
import { RBF0404B40Param } from "@/mixins/nosKeypad";

export default {
  extends: Common,
  props: {
    bizDscd: {
      type: String,
      required: true,
    },
    successFnc: {
      type: Function,
      required: true,
    },
    failFnc: {
      type: Function,
      required: false,
    },
  },
  created() {
    this.act013_commMotpCertn(); // 초기화
    this.$store._mutations["auth/commMotpCertn/mut003_commMotpCertn"][0]({ key: "bizDscd", value: this.bizDscd });
  },
  mounted() {
    this.$set(this.incaKepad, "isPasswordCheck", false); //키패드에서 패스워드 검증 적용 여부
    this.NOS_INSTANCE.init();
  },
  updated() {},
  mixins: [RBF0404B40Param],
  components: {
    AcnoSelectBox,
    AcnoPassword,
    NOSComponent,
  },
  data() {
    return {
      contents: "",
      isModalOpen: false,

      NOS_INSTANCE: new NOSController(this, {
        componentid: "NOS_COMPONENT",
        kpd: true,
      }),
    };
  },
  computed: {
    ...mapGetters("auth/commMotpCertn", ["getRBF0404B40"]),
  },
  methods: {
    ...mapActions("auth/commMotpCertn", ["act008_commMotpCertn", "act013_commMotpCertn"]),
    FN001: async function () {
      this.$set(this.getRBF0404B40.in, "_nprotected", this.NOS_INSTANCE.toJSON());

      const result = await this.act008_commMotpCertn();

      if (result === "success") {
        if (!_.isNil(this.successFnc)) {
          this.successFnc();
        }
      }

      if (result === "fail") {
        if (!_.isNil(this.failFnc)) {
          this.failFnc();
        }
      }
    },
    acnoChange(data) {
      this.$set(this.incaKepad, "acno0", data.acno);
      this.$refs.brncoEcrypPwd.init();
    },
  },
};
</script>
